{
  "name": "firm-portal",
  "version": "8.5.0+dev.ee0c3d8226d5",
  "scripts": {
    "prepare": "husky",
    "postinstall": "node -e \"const l='../../scripts/monorepo/link-portal-node-modules.cjs';require('fs').existsSync(l)&&require(l)\"",
    "config": "npx tsx ./scripts/set-env.ts",
    "prestart": "npm run config -- --environment=dev",
    "docker:build": "export $(cat .env | grep -v -E '^\\s*#' | xargs) && docker build --secret id=GOOGLE_APPLICATION_CREDENTIALS,src=$HOME/.config/gcloud/application_default_credentials.json --build-arg STACK --build-arg NG_CONFIGURATION --build-arg PRODUCTION --build-arg ART_ENGINE_API_URL --build-arg DISABLE_SSL --build-arg PENDO_FIRM_PORTAL_KEY --build-arg PENDO_CLIENT_PORTAL_KEY --build-arg AG_GRID_LICENSE_KEY --build-arg LAUNCH_DARKLY_CLIENT_SIDE_ID --build-arg GANTT_SYNCFUSION_LICENSE_KEY --build-arg FIREBASE_API_KEY --build-arg FIREBASE_AUTH_DOMAIN --build-arg FIREBASE_PROJECT_ID --build-arg FIREBASE_STORAGE_BUCKET --build-arg FIREBASE_MESSAGING_SENDER_ID -t firm-portal .",
    "start": "ng serve -c development --no-hmr",
    "start:docker": "node --max-old-space-size=4096 ./node_modules/@angular/cli/bin/ng serve --port 4200 --host 0.0.0.0 --proxy-config proxy.docker.api.json",
    "build": "node --max-old-space-size=4096 ./node_modules/@angular/cli/bin/ng build --output-hashing=all",
    "lint": "eslint src",
    "lint:fix": "NODE_OPTIONS='--max-old-space-size=8192' eslint src --fix",
    "lint:fix:fast": "eslint src --fix --cache",
    "lint:circular": "ESLINT_USE_FLAT_CONFIG=false eslint \"src/app\" --config \".eslintrc-import-cycle.json\" --ignore-path .gitignore --ext .js,.ts",
    "lint:circular:madge": "madge --circular --extensions ts --ts-config ./tsconfig.json src/app",
    "lint:circular:ci": "npx tsx scripts/check-circular-deps.ts",
    "lint:circular:generate-baseline": "npx tsx scripts/generate-baseline.ts",
    "prettier": "prettier --check .",
    "prettier:fix": "prettier --write .",
    "lint:styles": "stylelint \"src/**/*.{css,scss}\"",
    "lint:styles:fix": "stylelint \"src/**/*.{css,scss}\" --fix",
    "lint:all": "npm run lint && npm run lint:styles && npm run prettier",
    "lint:all:fix": "npm run lint:fix && npm run lint:styles:fix && npm run prettier:fix",
    "test": "jest --reporters=default --maxWorkers=50%",
    "test:ci": "jest -b --ci --reporters=default --maxWorkers=75%",
    "test:coverage": "CI=true jest --coverage --passWithNoTests --maxWorkers=75% --silent --bail=1 --verbose=false",
    "test-storybook": "test-storybook",
    "test-storybook:ci": "test-storybook --ci",
    "test-storybook:watch": "test-storybook --watch",
    "storybook": "ng run firm-portal:storybook",
    "build-storybook": "ng run firm-portal:build-storybook",
    "prestart:integration": "npm run config -- --environment=integration",
    "start:integration": "ng serve -c integration --no-hmr",
    "test:pw": "npx playwright test",
    "test:pw:headed": "npx playwright test --headed",
    "test:pw:ui": "npx playwright test --ui",
    "test:pw:debug": "npx playwright test --debug",
    "test:pw:record-bootstrap": "node integration/playwright/scripts/record-bootstrap.mjs"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.2.25",
    "@angular/cdk": "^19.1.4",
    "@angular/common": "^19.2.25",
    "@angular/compiler": "^19.2.25",
    "@angular/core": "^19.2.25",
    "@angular/elements": "^19.2.25",
    "@angular/fire": "19.0.0",
    "@angular/forms": "^19.2.25",
    "@angular/material": "^19.1.4",
    "@angular/material-moment-adapter": "^19.2.19",
    "@angular/platform-browser": "^19.2.25",
    "@angular/platform-browser-dynamic": "^19.2.25",
    "@angular/router": "^19.2.25",
    "@apollo/client": "3.13.1",
    "@auth0/angular-jwt": "~5.0.1",
    "@fullcalendar/angular": "^6.1.18",
    "@fullcalendar/interaction": "^6.1.18",
    "@fullcalendar/timegrid": "^6.1.18",
    "@looker/embed-sdk": "^1.8.6",
    "@looker/sdk": "^24.12.1",
    "@ng-select/ng-select": "^14.7.0",
    "@ngxs/devtools-plugin": "^19.0.0",
    "@ngxs/storage-plugin": "^19.0.0",
    "@ngxs/store": "^19.0.0",
    "@pdftron/webviewer": "11.10.0",
    "@schematics/angular": "^19.1.6",
    "@syncfusion/ej2-angular-filemanager": "^29.2.4",
    "@syncfusion/ej2-angular-gantt": "^29.1.39",
    "@syncfusion/ej2-angular-richtexteditor": "^29.2.4",
    "@tanstack/angular-query-experimental": "5.80.9",
    "@thoughtspot/visual-embed-sdk": "^1.42.3",
    "@tiptap/core": "^3.20.1",
    "@tiptap/extension-collaboration": "^3.21.0",
    "@tiptap/extension-color": "^3.20.1",
    "@tiptap/extension-image": "^3.20.1",
    "@tiptap/extension-link": "^3.20.1",
    "@tiptap/extension-placeholder": "^3.20.1",
    "@tiptap/extension-subscript": "^3.20.1",
    "@tiptap/extension-superscript": "^3.20.1",
    "@tiptap/extension-table": "^3.20.1",
    "@tiptap/extension-table-cell": "^3.20.1",
    "@tiptap/extension-table-header": "^3.20.1",
    "@tiptap/extension-table-row": "^3.20.1",
    "@tiptap/extension-text-align": "^3.20.1",
    "@tiptap/extension-text-style": "^3.20.1",
    "@tiptap/extension-underline": "^3.20.1",
    "@tiptap/pm": "^3.20.1",
    "@tiptap/starter-kit": "^3.20.1",
    "@tiptap/y-tiptap": "^3.0.2",
    "@types/dompurify": "^3.0.5",
    "@types/pendo-io-browser": "2.19.1",
    "@usersnap/browser": "^1.0.2",
    "ag-grid-angular": "28.1.1",
    "ag-grid-community": "28.1.1",
    "ag-grid-enterprise": "28.1.1",
    "angular-oauth2-oidc": "^19.0.0",
    "apollo-angular": "10.0.0",
    "bootstrap": "^5.1.0",
    "dompurify": "^3.3.3",
    "file-saver": "^2.0.5",
    "firebase": "^11.0.0",
    "graphql": "15.8.0",
    "graphql-ws": "^5.16.0",
    "jsonata": "^2.0.6",
    "launchdarkly-js-client-sdk": "^3.1.4",
    "lodash": "^4.17.21",
    "logrocket": "^4.0.3",
    "marked": "^13.0.0",
    "moment": "^2.29.4",
    "mustache": "^4.2.0",
    "ng2-date-picker": "^19.0.0",
    "ng2-pdf-viewer": "^9.1.5",
    "ngx-bootstrap": "^19.0.2",
    "ngx-mask": "^15.2.0",
    "ngx-spinner": "^17.0.0",
    "rxjs": "~7.8.0",
    "signature_pad": "^5.1.3",
    "ts-deepmerge": "^7.0.3",
    "tslib": "^2.0.0",
    "uuid": "11.0.2",
    "y-indexeddb": "^9.0.12",
    "yjs": "^13.6.30",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.1.7",
    "@angular/cli": "^19.1.7",
    "@angular/compiler-cli": "^19.2.25",
    "@eslint/js": "^9.18.0",
    "@playwright/test": "^1.50.0",
    "@storybook/addon-a11y": "^8.6.14",
    "@storybook/addon-designs": "^8.2.1",
    "@storybook/addon-essentials": "^8.6.12",
    "@storybook/addon-interactions": "^8.6.12",
    "@storybook/addon-onboarding": "^8.6.12",
    "@storybook/addon-styling-webpack": "^1.0.1",
    "@storybook/angular": "^8.6.12",
    "@storybook/blocks": "^8.6.12",
    "@storybook/test": "^8.6.12",
    "@storybook/test-runner": "^0.23.0",
    "@testing-library/angular": "^17.3.7",
    "@testing-library/dom": "^10.4.0",
    "@testing-library/jest-dom": "^6.6.3",
    "@trivago/prettier-plugin-sort-imports": "^4.3.0",
    "@types/lodash": "4.17.4",
    "@types/madge": "^5.0.3",
    "@types/mustache": "^4.2.6",
    "@types/testing-library__jest-dom": "^5.14.9",
    "@types/uuid": "^9.0.8",
    "@typescript-eslint/eslint-plugin": "^8.21.0",
    "@typescript-eslint/parser": "^8.21.0",
    "angular-eslint": "^19.0.0",
    "chalk": "^5.6.0",
    "dotenv": "^16.5.0",
    "eslint": "^9.18.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-import-resolver-typescript": "^3.6.1",
    "eslint-plugin-import": "^2.29.1",
    "eslint-plugin-storybook": "^0.12.0",
    "husky": "^9.1.7",
    "jest": "^29.5.0",
    "jest-preset-angular": "^14.5.1",
    "lint-staged": "^16.2.3",
    "madge": "^8.0.0",
    "mermaid": "^11.12.2",
    "ng-mocks": "^14.1.3",
    "ngx-dev-toolbar": "^4.3.0",
    "postcss": "^8.5.25",
    "postcss-scss": "^4.0.9",
    "prettier": "^3.5.3",
    "prettier-plugin-organize-attributes": "^1.0.0",
    "remark-gfm": "^4.0.1",
    "resize-observer-polyfill": "^1.5.1",
    "storybook": "^8.6.12",
    "stylelint": "^16.22.0",
    "stylelint-config-prettier-scss": "^1.0.0",
    "stylelint-config-standard-scss": "^15.0.1",
    "stylelint-order": "^7.0.0",
    "tslint": "~6.1.0",
    "typescript": "~5.7.3",
    "typescript-eslint": "^8.21.0"
  },
  "engines": {
    "node": "^18.19.1 || ^20.11.1 || ^22.0.0",
    "npm": ">=10.0.0"
  },
  "optionalDependencies": {
    "@rollup/rollup-win32-x64-msvc": "^4.20.0"
  },
  "overrides": {
    "ng2-date-picker": {
      "@angular/cdk": "$@angular/cdk",
      "@angular/common": "$@angular/common",
      "@angular/core": "$@angular/core"
    },
    "picomatch@4": "^4.0.5",
    "postcss": "$postcss",
    "pacote": {
      "tar": "^7.5.22"
    },
    "brace-expansion@2": "^2.1.4",
    "rollup": "^4.62.4",
    "piscina": "^4.9.3",
    "http-proxy-middleware@3": "^3.0.7",
    "vite@6": "^6.4.3"
  },
  "lint-staged": {
    "src/**/*.{scss}": "stylelint --fix",
    "*.{html,ts}": "eslint --fix",
    "*.{html,ts,css,scss,json}": "prettier --write"
  }
}
